import { useEffect, useId, useState } from 'react';
import clsx from 'clsx';
import { MessageCircle } from 'lucide-react';

const WHATSAPP_LINK =
  'https://wa.me/254717002340?text=Hi%20Trendy%20Quest!%20I%27m%20interested%20in%20your%20products.';
const REVEAL_SELECTOR = '[data-whatsapp-reveal]';

export default function FloatingWhatsAppButton() {
  const descriptionId = useId();
  const [isHovered, setIsHovered] = useState(false);
  const [isScrollRevealed, setIsScrollRevealed] = useState(false);

  useEffect(() => {
    const revealTarget = document.querySelector(REVEAL_SELECTOR);
    const Observer = globalThis.IntersectionObserver;

    if (!revealTarget || !Observer) {
      setIsScrollRevealed(false);
      return undefined;
    }

    const observer = new Observer(
      ([entry]) => {
        setIsScrollRevealed(entry.isIntersecting);
      },
      {
        root: null,
        // Start revealing a bit before the footer card fully enters view.
        rootMargin: '0px 0px 140px 0px',
        threshold: 0.15,
      }
    );

    observer.observe(revealTarget);

    return () => observer.disconnect();
  }, []);

  const isOpen = isHovered || isScrollRevealed;
  const descriptionClasses = clsx(
    'origin-bottom-right rounded-[1.15rem] bg-white px-4 py-3 text-[#1f1f1f] shadow-[0_18px_40px_rgba(0,0,0,0.14)] transition-all duration-300 sm:px-5 sm:py-4',
    isOpen
      ? 'pointer-events-auto translate-y-0 opacity-100'
      : 'pointer-events-none translate-y-3 opacity-0'
  );

  return (
    <div
      className="fixed bottom-4 right-4 z-[70] flex max-w-[min(260px,calc(100vw-1.5rem))] flex-col items-end gap-2 sm:bottom-6 sm:right-6 sm:gap-3"
    >
      <div
        id={descriptionId}
        className={descriptionClasses}
        aria-hidden={!isOpen}
      >
        <p className="text-base font-bold leading-none text-[#2f6a31]">Trendy Quest</p>
        <p className="mt-2 text-sm leading-5 text-[#454545]">
          Hi there! Need help finding the right pair? Chat with us on WhatsApp.
        </p>
      </div>

      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Start chat on WhatsApp"
        aria-describedby={descriptionId}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onFocus={() => setIsHovered(true)}
        onBlur={() => setIsHovered(false)}
        className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-bold text-white shadow-[0_18px_40px_rgba(37,211,102,0.35)] transition hover:scale-[1.02] hover:bg-[#1ebe5d] focus:outline-none focus:ring-4 focus:ring-[#25D366]/30 sm:px-6 sm:text-base"
      >
        <MessageCircle size={20} strokeWidth={2.2} aria-hidden="true" />
        <span>Start chat</span>
      </a>
    </div>
  );
}
